const route = {
    path: "/tariff-query",
    meta: {
        title: "关税查询",
        isMenu: true,
        isRequiredAuth: true,
        layout: 'PageLayout'
    },
    children: [
        {
            path: "index",
            name: "TariffQuery",
            component: () => import( /*webpackChunkName: "tariff-query"*/ "./view/TariffQuery.vue"),
            meta: {
                title: "FTA优惠关税查询",
                isRequiredAuth: true
            }
        },
        {
            path: "special-list",
            name: "TariffSpecial",
            component: () => import( /*webpackChunkName: "tariff-query"*/ "./view/TariffSpecialQuery.vue"),
            meta: {
                title: "特殊关税",
                isRequiredAuth: true
            }
        },
    ]
}

export default route